<template>
    <li>

        <span class="inline-flex">
            <span><b>{{checklist.checklist_name}}. </b></span> <span>{{checklist.descr}}</span> 
            <div class="d-inline-flex">
                <el-tooltip content="Показать данные чек-листа" placement="top" v-if="status===null">
                    <base-button
                    class="btn btn-icon no-border btn-simple btn-primary my-0 ml-2 btn-watch-icon "  
                    @click="downloadChecklist()"><i class="tim-ic ic-eye"></i></base-button>
                </el-tooltip>

                <base-button v-else-if="status===false" 
                    class="btn btn-icon no-border btn-simple btn-primary my-0 ml-2 btn-watch-icon"  
                @click="()=>status=true"><i class="tim-ic ic-eye "></i></base-button>

                <base-button v-else 
                    class="btn btn-icon no-border btn-simple  my-0 ml-2 btn-watch-icon"  
                @click="()=>status=false"><i class="tim-ic ic-eye overline"></i></base-button>
            </div>	
        </span>
        <div v-if="status===true" >
            <div v-if="chcklst"> 
                <h5 v-if="chcklst.checklist_id == '' && checklist.checklist_destination == 'MyObj'"><i class="tim-icons text-danger icon-alert-circle-exc mr-2 mb-1"></i> У вас нет доступа на просмотр данного объекта.</h5>	

                <div class="col" :id="'content_'+checklist.checklist_id">
                    <p v-if="chcklst.name"><b>Заголовок: </b>{{chcklst.name}}</p>
                    <p v-if="chcklst.descr"><b>Описание: </b>{{chcklst.descr}}</p>
                    <template v-if="chcklst.doc!=undefined">
                        <a v-for="doc in chcklst.doc"  target="_blank" :href="doc" >Посмотреть документ, </a>										
                    </template>
                    <a :target="chcklst.target" v-if="chcklst.link_text && chcklst.link" :href="chcklst.link">{{chcklst.link_text}}</a>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
    export default {
        data(){
            return {
                status:null,
                chcklst:null,
            }
        },
        props: {
            checklist: Object,
        },
        methods:{
            downloadChecklist(){
                const checklist = this.checklist;
                this.$GVO.ApiCall('GET_CHECKLIST_MINICARD',{obj:checklist.checklist_destination,flt:{'id':checklist.checklist_id}})
                    .then((objApi) => {
                        if(objApi.success === true){

                            const element = objApi.data;
                            // console.log('element', element);
                            if(element.doc==undefined){
                                // console.log('element.doc==undefined');
                            } else {
                                // console.log('element.doc', element.doc);
                                element.doc = JSON.parse(element.doc);
                            }
                            this.chcklst = {
                                descr:element.descr,
                                link:element.link,
                                link_text:element.link_text,
                                name:element.name,
                                // checklist_id:element.id,
                                checklist_id:element.checklist_id,
                                doc:element.doc,
                                target: element.target,
                            };
                        }
                    }).catch(errorObjApi => console.error(errorObjApi));
                this.status=true;
                
            },
        },
    }
</script>

<style lang="scss" scoped>

.btn-watch-icon i {font-size: 1.1rem; margin-top: 5px; display: block;}
.overline { position: relative;}
.overline::after { 
	content: "╱";
	position: absolute;
	font-size: .85em;
    top: -1px;
    left: 5px;
}

</style>